import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.css";
import legendStyles from "../ChartLegend/index.module.css";
import FigureFooter from "../FigureFooter";
import get from "lodash/get";
import Grid, { Full, Half, Thin } from "../Grid";
import { connect } from "react-redux";
import { requestImageDownload } from "../../state/download/share-image";

const ReduxConnectedBlockChartImage = ({
  id,
  insight,
  title,
  image,
  note,
  svg,
  type,
  chartId,
  groupId,
  legend,
  sources,
  path,
  onDownloadClicked,
  showWatermark
}) => {
  /* NOTE: a load of the markup / styles in this component are copy and pasted from the BlockChart component */
  /* this is likely to be awkward and annoying for anyone that wants to change this stuff and realises it's in two places */
  /* sorry :( */
  /* it's 11pm the day before the site launches so this is what it's gonna be */
  let src = false;
  if (
    svg &&
    get(svg, `publicURL`) &&
    get(svg, `extension`) &&
    svg.extension === `svg`
  ) {
    src = svg.publicURL;
  } else if (image) {
    src = image;
  }

  if (!src) return null;

  const sharePath = `${path}${chartId}#ci${chartId}`;

  if (type === `fullwidth`) {
    return (
      <Grid className={styles.container}>
        <Half>
          <a id={`ci${chartId}`} />
          <div className={styles.insightWrapper}>
            {insight && <h2 className={styles.insightLarge}>{insight}</h2>}
          </div>
        </Half>
        <Full className={`${styles.root} ${styles.fullWidth}`}>
          <div className={styles.chartHeader}>
            {title && <h2 className={styles.title}>{title}</h2>}
          </div>
          <img className={styles.figure} alt={title} src={src} />
          <div className={styles.sourceShare}>
            <FigureFooter
              sources={sources}
              note={note}
              onDownloadClick={
                !showWatermark && (() => onDownloadClicked(src))
              }
              sharePath={sharePath}
              title={title}
              showWatermark={showWatermark}
            />
          </div>
        </Full>
      </Grid>
    );
  } else {
    return (
      <Grid className={styles.container}>
        <a id={`ci${chartId}`} />
        <Half className={styles.root}>
          <div className={styles.insightWrapper}>
            {insight && <h2 className={styles.insightLarge}>{insight}</h2>}
          </div>
          <div className={styles.grid}>
            <div className={styles.chartHeader}>
              {title && <h2 className={styles.title}>{title}</h2>}
            </div>
            <img className={styles.figure} alt={title} src={src} />
            <div className={styles.sourceShare}>
              <FigureFooter
                sources={sources}
                note={note}
                onDownloadClick={
                  !showWatermark && (() => onDownloadClicked(src))
                }
                sharePath={sharePath}
                title={title}
                showWatermark={showWatermark}
              />
            </div>
            <div className={styles.legend}>
              <h4 className={legendStyles.legendTitle}>Legend</h4>
              {legend && (
                <ul className={legendStyles.legendList}>
                  {legend.map((entry, i) => {
                    return (
                      <li className={legendStyles.legendItem} key={i}>
                        <div className={legendStyles.legendItemDiscWrapper}>
                          <span
                            className={legendStyles.legendItemDisc}
                            style={{ backgroundColor: entry.color }}
                          />
                        </div>
                        <span className={legendStyles.legendItemName}>
                          {entry.label}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
            {note && (
              <div className={styles.noteWrapper}>
                <dl className={styles.note}>
                  <dt className={styles.term}>Note:</dt>
                  <dd className={styles.definition}>{note}</dd>
                </dl>
              </div>
            )}
          </div>
        </Half>
      </Grid>
    );
  }
};

const withRedux = connect(
  () => ({}),
  dispatch => ({
    onDownloadClicked(url) {
      dispatch(
        requestImageDownload({
          url: url,
          filename: url.split(`/`).pop()
        })
      );
    }
  })
);

const BlockChartImage = withRedux(ReduxConnectedBlockChartImage);

BlockChartImage.propTypes = {
  title: PropTypes.string,
  insight: PropTypes.string,
  source: PropTypes.string,
  note: PropTypes.string,
  image: PropTypes.string,
  svg: PropTypes.string
};

export default BlockChartImage;
